import React from "react";

export const Logo = ({ size = 40, withText = false, className = "" }) => {
  const gradId = React.useId();
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="smk-logo">
      <svg
        viewBox="0 0 40 40"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        role="img"
        aria-label="SMAKTECH logo"
        width={size}
        height={size}
      >
        <defs>
          <linearGradient id={gradId} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#00d4ff" />
            <stop offset="100%" stopColor="#00ffb3" />
          </linearGradient>
        </defs>
        <polygon
          points="20,2 36,11 36,29 20,38 4,29 4,11"
          stroke={`url(#${gradId})`}
          strokeWidth="1.5"
          fill="rgba(0,212,255,0.07)"
        />
        <path
          d="M14 16 Q14 13 17 13 L23 13 Q26 13 26 16 Q26 19 20 19 Q14 19 14 22 Q14 26 17 26 L23 26 Q26 26 26 23"
          stroke={`url(#${gradId})`}
          strokeWidth="2"
          strokeLinecap="round"
          fill="none"
        />
      </svg>
      {withText && (
        <span className="font-[Outfit] text-xl font-semibold tracking-tight text-white">
          SMAK<span className="smk-gradient-text">TECH</span>
        </span>
      )}
    </div>
  );
};

export default Logo;
